import { CompressionAndExport } from '@/app/workflows/actions/interfaces';

type Filetype = CompressionAndExport['fileExports'][number]['fileType'];
const compressibleFiletypes: Filetype[] = ['glb', 'gltf'];

export function isCompressible(filetype: Filetype) {
  return compressibleFiletypes.includes(filetype);
}
